import { useState, type FormEvent } from "react";
import type { LoginOutcome } from "./useAuth";
import { AuthLayout } from "./AuthLayout";

interface SignInProps {
  onSubmit: (username: string, password: string) => Promise<LoginOutcome>;
}

/** The sign-in screen shown whenever there is no valid session. */
export function SignIn({ onSubmit }: SignInProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    const outcome = await onSubmit(username, password);
    setSubmitting(false);
    if (!outcome.ok) {
      setError(outcome.message ?? "Could not sign in.");
    }
  };

  return (
    <AuthLayout>
      <form className="card signin" onSubmit={(event) => void handleSubmit(event)}>
        <h1>Sign in</h1>
        <p className="shell__subtitle">Enter your username and password to continue.</p>
        <label className="signin__field">
          <span>Username</span>
          <input
            type="text"
            autoComplete="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            required
            autoFocus
          />
        </label>
        <label className="signin__field">
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>
        {error ? (
          <p className="card__error" role="alert">
            {error}
          </p>
        ) : null}
        <button type="submit" disabled={submitting}>
          {submitting ? "Signing in…" : "Sign in"}
        </button>
        <a className="auth__link" href="/forgot-password">
          Forgot password?
        </a>
      </form>
    </AuthLayout>
  );
}
